import { Component, Injector, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TableFunctionsService } from '@services/table/table-functions.service';
import '@angular/localize/init';
import { ComponentBase } from '../../abstracts/component-base';

@Component({
  selector: 'app-evaluation',
  templateUrl: './evaluation.component.html',
  styleUrls: ['./evaluation.component.scss']
})
export class EvaluationComponent extends ComponentBase implements OnInit {

  public className = 'EvaluationComponent';
  public activeTab = 'charging-statistics';

  public activeComponentClassName: string;

  links = [
    {
      title: $localize`:@@EvaluationTitel1:Ladestatistik`, route: 'charging-statistics' },
    {
      title: $localize`:@@EvaluationTitel2:Ladevorgänge`, route: 'transactions' },
    {
      title: $localize`:@@EvaluationTitel3:Lieferscheine`, route: 'delivery-notes' },
  ];

  constructor(public tableFunctions: TableFunctionsService, public router: Router, public activatedRoute: ActivatedRoute, injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit(); 
  }

  public onRouterOutletActivate(event: any) {
    this.activeComponentClassName = event.className;
    this.determineActiveTab()
  }

  determineActiveTab() {
    for (let link of this.links) {
      if (this.router.url.includes(link.route)) {
        this.activeTab = link.route;
      }
    }
  }
}
